import { useEffect, useState } from "react";
import { ChevronUp, ChevronDown, Loader2, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { UserAvatar } from "@/components/UserBits";

export function SupporterOrderAdmin() {
  const [list, setList] = useState(null);
  const [dirty, setDirty] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/supporters").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  if (!list) return <Loader2 className="w-5 h-5 animate-spin text-rose-500" />;
  const move = (i, d) => {
    const j = i + d;
    if (j < 0 || j >= list.length) return;
    const n = [...list]; [n[i], n[j]] = [n[j], n[i]]; setList(n); setDirty(true);
  };
  const save = async () => {
    setBusy(true);
    try { await api.put("/admin/supporter-order", { ids: list.map((u) => u.user_id) }); toast.success("Reihenfolge gespeichert"); setDirty(false); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="pt-4 border-t border-pink-100 space-y-3" data-testid="admin-supporter-order">
      <h3 className="font-bold text-lg">Reihenfolge der Unterstützer</h3>
      <p className="text-sm text-slate-500">So erscheinen sie im Feed und auf der Unterstützer-Wand. Neue Unterstützer kommen ans Ende.</p>
      {list.length === 0 ? <p className="text-sm text-slate-400">Noch keine Unterstützer.</p> : (
        <ol className="space-y-1.5">
          {list.map((u, i) => (
            <li key={u.user_id} className="flex items-center gap-2 p-2 rounded-xl border border-pink-100 bg-white" data-testid={`admin-supporter-row-${u.user_id}`}>
              <span className="w-6 text-center text-xs font-bold text-slate-400">{i + 1}</span>
              <UserAvatar userId={u.user_id} name={u.name} picture={u.picture} size="w-8 h-8" text="text-xs" />
              <span className="flex-1 min-w-0 truncate text-sm font-semibold">{u.name}</span>
              {u.supporter_hidden && <span className="text-[10px] text-slate-400 flex items-center gap-1" title="Hat sich ausgeblendet"><EyeOff className="w-3 h-3" /> ausgeblendet</span>}
              <button onClick={() => move(i, -1)} disabled={i === 0} data-testid={`admin-supporter-up-${u.user_id}`} aria-label="Nach oben" className="p-1.5 rounded-lg hover:bg-rose-50 disabled:opacity-25"><ChevronUp className="w-4 h-4" /></button>
              <button onClick={() => move(i, 1)} disabled={i === list.length - 1} data-testid={`admin-supporter-down-${u.user_id}`} aria-label="Nach unten" className="p-1.5 rounded-lg hover:bg-rose-50 disabled:opacity-25"><ChevronDown className="w-4 h-4" /></button>
            </li>
          ))}
        </ol>
      )}
      {list.length > 1 && <button onClick={save} disabled={!dirty || busy} data-testid="admin-supporter-order-save" className="px-5 h-10 rounded-full pink-gradient text-white text-sm font-bold disabled:opacity-40">{busy ? "Speichert …" : "Reihenfolge speichern"}</button>}
    </div>
  );
}
